import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SearchWidgetComponent } from './search-widget.component';
import { LocalizePipeModule } from '@shared/common/pipes/localize/localize.pipe.module';
import { DirectivesModule } from '../../../shared/directives/directive.module';
import { CommonAppModule } from '../../../shared/modules/common-app/common-app.module';
import { SharedModule } from '../../../shared/shared.module';

@NgModule({
  declarations: [SearchWidgetComponent],
  imports: [CommonAppModule, CommonModule, DirectivesModule, LocalizePipeModule, SharedModule],
  exports: [SearchWidgetComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class SearchWidgetModule {}
